import script from "./courseSeniorSet.vue?vue&type=script&setup=true&lang=js"
export * from "./courseSeniorSet.vue?vue&type=script&setup=true&lang=js"

import "./courseSeniorSet.vue?vue&type=style&index=0&id=37d0d60c&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d0d60c"]])

export default __exports__